import React, { useState, useEffect } from "react";
import "./Collapsible.scss";
import PropTypes from "prop-types";

function Collapsible({
  children,
  collapsePrompt,
  startExpanded,
  forceExpand,
  promptLeftMargin,
  onExpand,
}) {
  const [isCollapsed, setIsCollapsed] = useState(startExpanded ? false : true);
  const handleCollapse = () => {
    const nextCollapsed = !isCollapsed;
    if (!nextCollapsed && onExpand) {
      onExpand();
    }
    return setIsCollapsed(nextCollapsed);
  };

  useEffect(() => {
    if (forceExpand != null) {
      setIsCollapsed(!forceExpand);
    }
  }, [forceExpand]);

  useEffect(() => {
    if (startExpanded != null) {
      setIsCollapsed(!startExpanded);
    }
  }, [startExpanded]);
  return (
    <>
      <div className="clps-prompt">
        <button
          type="button"
          className="clps-toggler-button"
          data-target="#collapser"
          aria-controls="collapser"
          aria-expanded={!isCollapsed ? true : false}
          aria-label="Toggle content"
          onClick={handleCollapse}
        >
          <h6
            className={`${
              promptLeftMargin && `pl-${promptLeftMargin}`
            } clps-toggler-prompt`}
          >
            {collapsePrompt}{" "}
            <span
              className={`${
                isCollapsed ? "fa fa-angle-right" : "fa fa-angle-down"
              } clps-toggler-icon fa-lg`}
            ></span>
          </h6>
        </button>
      </div>
      <div
        className={`${isCollapsed ? "clps-hide" : "clps-show"}`}
        id="collapser"
      >
        {children}
      </div>
    </>
  );
}

Collapsible.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  collapsePrompt: PropTypes.string,
};

export default Collapsible;
